module.exports = __webpack_public_path__ + "img/menu-hair-6.87138068.jpg";